import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

function PermissionRoute({ permission }) {
  const permissions = useSelector((state) => state.auth.permissions ?? []);
  const role = useSelector((state) => state.auth.userDetails?.role);

  if (!permission) {
    return <Outlet />;
  }
  if (role === 'SuperAdmin') {
    return <Outlet />;
  }
  // One permission, or a list where any one is enough.
  const needed = Array.isArray(permission) ? permission : [permission];
  if (
    Array.isArray(permissions) &&
    needed.some((p) => permissions.includes(p))
  ) {
    return <Outlet />;
  }
  return <Navigate to="/" replace />;
}

export default PermissionRoute;
